module.exports = __webpack_public_path__ + "dc1273a9.webp";